import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { PageHeaderComponent } from "../../../shared/components/page-header/page-header.component";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";

import { TabsModule } from "primeng/tabs";
import { EventsInvitationsTabPageComponent } from "./events-invitations-tab/events-invitations-tab-page.component";
import { CollaboratorInvitationsTabComponent } from "./collaborator-invitations-tab/collaborator-invitations-tab.component";
import { TransferInvitationsTabComponent } from "./transfer-invitations-tab/transfer-invitations-tab.component";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { ActivatedRoute } from "@angular/router";
import { AccordionModule } from "primeng/accordion";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { Subject, takeUntil, tap } from "rxjs";

enum DISPLAY_MOBILE_OPTIONS_ENUM {
  COURTESIES = "courtesies",
  TRANSFERS = "transfers",
  EMPLOYEE = "employee",
}

@Component({
  selector: "app-my-invitations-page",
  imports: [
    PageHeaderComponent,
    AppLayoutComponent,
    TabsModule,
    EventsInvitationsTabPageComponent,
    CollaboratorInvitationsTabComponent,
    TransferInvitationsTabComponent,
    AccordionModule,
    MatButtonToggleModule,
  ],
  templateUrl: "./my-invitations-page.component.html",
  styleUrl: "./my-invitations-page.component.scss",
})
export class MyInvitationsPageComponent implements OnInit, OnDestroy {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly route = inject(ActivatedRoute);

  private readonly destroy$ = new Subject<void>();

  isMobile = false;

  DISPLAY_MOBILE_OPTIONS_ENUM = DISPLAY_MOBILE_OPTIONS_ENUM;
  displayMobile = DISPLAY_MOBILE_OPTIONS_ENUM.COURTESIES;

  ngOnInit() {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        if (result.matches) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      });

    // Permite abrir uma aba específica via query param (ex.: ?tab=transfers
    // a partir de uma notificação). Reage a mudanças porque o componente é
    // reaproveitado ao navegar de uma notificação para outra.
    this.route.queryParamMap
      .pipe(
        tap((params) => this.applyTabFromQuery(params.get("tab"))),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private applyTabFromQuery(tab: string | null): void {
    const isValidTab = Object.values(DISPLAY_MOBILE_OPTIONS_ENUM).includes(
      tab as DISPLAY_MOBILE_OPTIONS_ENUM,
    );
    if (isValidTab) {
      this.displayMobile = tab as DISPLAY_MOBILE_OPTIONS_ENUM;
    }
  }
}
